import * as React from 'react';
import cn from 'clsx';
import { UIHeading1, UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { trackIncluded, trackOther, VIEWED_TIMEOUT } from '../tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

export const Analytics: React.FC = () => {
  return (
    <>
      <div data-testid="Analytics" className={styles['main-title']}>
        <UIHeading1 as="h2">Что входит в аналитику</UIHeading1>
      </div>
      <div className={styles['content']}>
        <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackIncluded}>
          <div className={styles['content-row']}>
            <div className={cn(styles['card'], styles['card-one'])}>
              <div className={styles['card-title']}>
                <UIHeading2 as="h3">
                  Стоимость
                  <br />и доход от аренды
                </UIHeading2>
              </div>
              <UIText1>
                Оценим и учтём всё: ремонт, этаж
                <br />и даже баню на участке
              </UIText1>
            </div>
            <div className={cn(styles['card'], styles['card-big'], styles['card-two'])}>
              <div className={styles['card-title']}>
                <UIHeading2 as="h3">Прогноз удачного момента для продажи</UIHeading2>
              </div>
              <UIText1>Анализируем рынок и рассказываем вам</UIText1>
            </div>
          </div>
        </ActionAfterViewObserver>

        <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackOther}>
          <div className={styles['content-row']}>
            <div className={cn(styles['card'], styles['card-big'], styles['card-three'])}>
              <div className={styles['card-title']}>
                <UIHeading2 as="h3">Похожие объявления</UIHeading2>
              </div>
              <UIText1>Покажем недвижимость рядом для сравнения</UIText1>
            </div>
            <div className={cn(styles['card'], styles['card-four'])}>
              <div className={styles['card-title']}>
                <UIHeading2 as="h3">Полезные сервисы</UIHeading2>
              </div>
              <UIText1>
                Всё для быстрой сдачи, продажи
                <br />и поиска нового жилья
              </UIText1>
            </div>
          </div>
        </ActionAfterViewObserver>
      </div>
    </>
  );
};
